/**
 * Sets up dependency injection for the Videos infrastructure.
 */
import "reflect-metadata";
/**
 * Configures dependency injection for Videos infrastructure components.
 */
export const DependencyInjectionVideosInfrastructure = () => {
    /**
     * Registers the GetVideos class as the implementation for IGetVideos interface.
     */
};
export default DependencyInjectionVideosInfrastructure;
